import { Link } from "react-router-dom";
import moment from "moment";
import { formatDateTime, getFormStatus } from "../../util";
import React from "react";
import {useClient, useUserContext} from "../../../../hooks";
import { FormGroupCheckbox } from "../../../../components/common/FormGroup";
import { LatestNote, NotesButton } from "../../../applications/applications";
import { ConvertButton } from "./ConvertButton";

export const ApplicationRow = ({ match, value, onChanged }) => {
  const {
    referral,
    created,
    id,
    form,
    num_notes,
    num_references_submitted,
    num_references_checked,
    latest_note,
    dbs_form,
    checks_completed,
    registration,
    parental_consent_form,
    organisation__organisation_name,
  } = value;
  const { status, submitted, full_name, email } = form;
  const { submitted: dbsSubmitted } = dbs_form || {};
  const client = useClient();
  const { isVPSupport } = useUserContext();

  async function handleChecksCompletedChanged(e) {
    const { checked } = e.target;

    await client.patch(`volunteer_applications/${id}`, {
      checks_completed: checked ? moment().format() : null,
    });

    await onChanged();
  }

  return (
    <>
      {isVPSupport && (
        <td>
          {organisation__organisation_name}
        </td>
      )}
      <td>
        <Link to={`${match.url}/${id}`}>View Application</Link>
        <br />
        <span className="small text-muted">
          Created at{" "}
          <strong>{moment(created).format("DD/MM/YYYY  HH:mm")}</strong>
        </span>
      </td>
      <td>
        <ul className="tw-list-none tw-pl-0">
          <li>{full_name}</li>
          <li className="text-muted small">{email}</li>
        </ul>
        <br />
      </td>
      <td>
        <ul className="tw-list-none tw-pl-0">
          <li>
            <strong>{getFormStatus(status)}</strong>
          </li>
          <li className="small text-muted">
            Referred at <strong>{formatDateTime(referral.created)}</strong>
          </li>
          {submitted ? (
            <>
              <li className="small text-muted">
                Application submitted at{" "}
                <strong>{formatDateTime(submitted)}</strong>
              </li>
              <li className="small text-muted">
                <strong>{num_references_submitted || "0"}</strong> reference(s)
                completed
              </li>
              {num_references_submitted ? (
                <li className="small text-muted">
                  <strong>{num_references_checked || "0"}</strong> reference(s)
                  checked
                </li>
              ) : null}
            </>
          ) : null}
          {dbsSubmitted ? (
            <li className="small text-muted">
              DBS/PVG/Access NI Check submitted at{" "}
              <strong>{formatDateTime(dbsSubmitted)}</strong>
            </li>
          ) : null}
          {parental_consent_form && parental_consent_form.submitted ? (
            <li className="small text-muted">
              Parental consent submitted at{" "}
              <strong>{formatDateTime(parental_consent_form.submitted)}</strong>
            </li>
          ) : null}
          {registration ? (
            <li className="small text-muted">
              <Link to={`/registered/${registration}`}>
                Converted to registration
              </Link>
            </li>
          ) : null}
          <li>
            <hr className="my-1" />
            <FormGroupCheckbox
              className="small"
              label="Checks completed"
              htmlFor="checks_completed"
            >
              <input
                type="checkbox"
                defaultChecked={!!checks_completed}
                className="form-check-input"
                id="checks_completed"
                onChange={handleChecksCompletedChanged}
              />
            </FormGroupCheckbox>
          </li>
        </ul>
      </td>
      <td className="tw-text-center">
        {!registration ? (
          <ConvertButton application={value} className="tw-w-48" />
        ) : null}
      </td>
      <td>{latest_note ? <LatestNote value={latest_note} /> : null}</td>
      <td className="tw-whitespace-no-wrap">
        <NotesButton
          onChanged={onChanged}
          application={id}
          allowChange
          url="volunteer_application_notes"
          numNotes={num_notes}
        />
      </td>
    </>
  );
};
